module.exports = __webpack_public_path__ + "img/Sonomed Escalon Logo for Light Backgrounds.a819caa1.png";